import Vue from 'vue'
import VueRouter from 'vue-router'
import Calculator from '../views/Calculator.vue'
import Results from '../views/Results.vue'
import Comparison from '../views/Comparison.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Calculator',
    component: Calculator
  },
  {
    path: '/results',
    name: 'Results',
    component: Results,
    props: true
  },
  {
    path: '/comparison',
    name: 'Comparison',
    component: Comparison
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
